module.exports = __webpack_public_path__ + "img/hr-artillery-wagon-base-shadow-13.79107cc8.png";